// extracted by mini-css-extract-plugin
export default {"container":"ShiftNavigationButtons--container--390bba","nowButton":"ShiftNavigationButtons--nowButton--ee6c49","prev":"ShiftNavigationButtons--prev--967096"};